import React from "react";
import { Button, Dialog, DialogTitle, Stack } from "@mui/material";
import { dialogTitleStyle } from "../../styles/MUI-style-constants.js";
import "../../styles/generate-captions.scss";
import "../../styles/global.scss";

const LoginPopup = (props) => {
  const toggleWindow = () => {
    props.toggleSignIn();
  };

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={dialogTitleStyle}>
          {
            "Want to experience more of what CaptionAI has to offer? Sign up for free."
          }
        </DialogTitle>
        <Stack direction="row" justifyContent="space-evenly" margin={2}>
          <Button variant="contained" color="cc" onClick={toggleWindow}>
            Sign Up / Log In
          </Button>
        </Stack>
      </Dialog>
    </div>
  );
};

export default LoginPopup;
